import AddProductContainer from "../../../../Components/Applications/Ecommerce/AddProduct/AddProductContainer";

const AddProducts = () => {
  return <AddProductContainer />;
};

export default AddProducts;
